import UserAuthentication from './UserAuthentication';
import CompanyAuthentication from './CompanyAuthentication';
import { useInitializeAuthentication } from './_hooks';
import ZebelerAuthentication from './ZebelerAuthentication';
import SentryProvider from '@/app/sentry/SentryProvider';
import { PageLoading } from '@/app/ui/page';
import MixpanelUserProvider from '@/app/mixpanel/MixpanelUserProvider';
import PusherProvider from '@/app/pusher/PusherProvider';

const AuthenticationWrapper = ({ children }) => {
  const { isAuthenticated, isLoading } = useInitializeAuthentication();

  if (isLoading) {
    return <PageLoading variant="app" />;
  }

  if (!isAuthenticated) {
    return null;
  }

  return (
    <UserAuthentication>
      <ZebelerAuthentication>
        <CompanyAuthentication>
          <MixpanelUserProvider>
            <SentryProvider>
              <PusherProvider>{children}</PusherProvider>
            </SentryProvider>
          </MixpanelUserProvider>
        </CompanyAuthentication>
      </ZebelerAuthentication>
    </UserAuthentication>
  );
};

export default AuthenticationWrapper;
